import React, { useState } from 'react';
import { SITE_NAME, SITE_URL } from './siteConfig';

const SHARE_ICON_STYLE = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '34px',
  height: '34px',
  borderRadius: '9999px',
  border: '1px solid #e5e7eb',
  background: '#ffffff',
  color: '#374151',
  textDecoration: 'none',
  fontSize: '0.78rem',
  fontWeight: '700',
};

function GearShareButtons({ gearName, gearId }) {
  const [copied, setCopied] = useState(false);
  const shareUrl = `${SITE_URL}/gear/${gearId}`;
  const shareText = `${gearName} on ${SITE_NAME}`;
  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedText = encodeURIComponent(shareText);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Copy link failed:', error);
    }
  };

  const handleNativeShare = async () => {
    if (!navigator.share) return;
    try {
      await navigator.share({ title: shareText, url: shareUrl });
    } catch (error) {
      if (error?.name !== 'AbortError') {
        console.error('Native share failed:', error);
      }
    }
  };

  return (
    <div
      className="gear-share-buttons"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        flexWrap: 'wrap',
        marginTop: '12px',
        marginBottom: '4px',
      }}
    >
      <span style={{ fontSize: '0.85rem', color: '#6b7280', fontWeight: '600' }}>Share via:</span>
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on Facebook"
        title="Facebook"
        style={SHARE_ICON_STYLE}
      >
        f
      </a>
      <a
        href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on X"
        title="X"
        style={SHARE_ICON_STYLE}
      >
        X
      </a>
      <a
        href={`https://wa.me/?text=${encodeURIComponent(`${shareText} ${shareUrl}`)}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on WhatsApp"
        title="WhatsApp"
        style={SHARE_ICON_STYLE}
      >
        W
      </a>
      <button
        type="button"
        onClick={handleCopy}
        aria-label="Copy link"
        title="Copy link"
        style={{
          ...SHARE_ICON_STYLE,
          cursor: 'pointer',
        }}
      >
        {copied ? '✓' : '⧉'}
      </button>
      {typeof navigator !== 'undefined' && typeof navigator.share === 'function' && (
        <button
          type="button"
          onClick={handleNativeShare}
          aria-label="Share"
          title="Share"
          style={{
            ...SHARE_ICON_STYLE,
            cursor: 'pointer',
          }}
        >
          ↗
        </button>
      )}
    </div>
  );
}

export default GearShareButtons;